export default __webpack_public_path__ + "static/media/good_mood_face.b41dcb37.png";